import { render, staticRenderFns } from "./game-preview-skeleton.vue?vue&type=template&id=22a08351&scoped=true"
import script from "./game-preview-skeleton.vue?vue&type=script&lang=js"
export * from "./game-preview-skeleton.vue?vue&type=script&lang=js"
import style0 from "./game-preview-skeleton.vue?vue&type=style&index=0&id=22a08351&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a08351",
  null
  
)

export default component.exports